export default "__VITE_ASSET__DeuVpvL7__"